import React from 'react';
import ClaimAllSpoolsIncentivizedRewards from './activeSpools/ClaimAllSpoolsIncentivizedRewards';
import DepositPending from './spools/DepositPending';
import SpoolDeposit from './spools/SpoolDeposit';
import SpoolWithdraw from './spools/SpoolWithdraw';
import WithdrawalMethod from './spools/WithdrawalMethod';
import WithdrawalPending from './spools/WithdrawalPending';
import ConnectWalletModal from './ConnectWalletModal';
import RiskModelDetails from './createASpool/RiskModelDetails';
import ClaimAllStakingRewardsModal from './staking/ClaimAllStakingRewardsModal';
import StakeEmissionRewardsModal from './staking/StakeEmissionRewardsModal';
import StakeModal from './staking/StakeModal';
import UnstakeModal from './staking/UnstakeModal';
import ErrorModal from './status/ErrorModal';
import LoadingModal from './status/LoadingModal';
import SuccessModal from './status/SuccessModal';
import WaitingModal from './status/WaitingModal';
import WarningModal from './status/WarningModal';
import DisclaimerModal from './status/DisclaimerModal';
import IncentivizeSpoolModal from './creatorFees/IncentivizeSpoolModal';
import ClaimPerformanceFeesModal from './staking/ClaimPerformanceFeesModal';
import AccountSelectorModal from './accountSelector/accountSelectorModal';

const ModalsContainer: React.FC = () => (
    <>
        <ErrorModal />
        <WarningModal />
        <SuccessModal />
        <LoadingModal />
        <WaitingModal />
        <DisclaimerModal />
        <ConnectWalletModal />
        <WithdrawalMethod />
        <WithdrawalPending />
        <DepositPending />
        <ClaimAllSpoolsIncentivizedRewards />
        <StakeModal />
        <UnstakeModal />
        <ClaimAllStakingRewardsModal />
        <StakeEmissionRewardsModal />
        <SpoolDeposit />
        <SpoolWithdraw />
        <RiskModelDetails />
        <IncentivizeSpoolModal />
        <ClaimPerformanceFeesModal />
        <AccountSelectorModal />
    </>
);

export default ModalsContainer;
